import React from 'react';
// import parse from 'html-react-parser';
import { Button, Card, Stack, Typography } from '@mui/material';
// import { translate as t } from 'hooks/useTranslations';
import { DtbMetricItem } from '../../../_types/policy';
import { ModelTrainingOutlined } from '@mui/icons-material';
import { neutral, primary } from '_lex/_foundations/phxColors';
import { useNavigate } from 'react-router-dom';

type DtbItemProps = {
  metric: DtbMetricItem;
};

export default function DtbItem({ metric }: DtbItemProps) {
  const navigate = useNavigate();
  const metricCounts = {
    draft: metric.draftCount,
    approved: metric.approvedCount,
  };

  return (
    <Card
      className='dtb-metrics-item'
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: 4,
        alignItems: 'center',
        border: `solid 1px ${neutral[200]}`,
        borderRadius: 2,
        py: 2,
        px: 3,
      }}
    >
      <Stack spacing={3}>
        <Stack>
          <Stack
            direction='row'
            spacing={2}
          >
            <ModelTrainingOutlined sx={{ color: neutral[400] }} />
            <Typography variant='subtitleLg'>{metric.name}</Typography>
          </Stack>

          {metric.manualTitle && (
            <Stack
              direction='row'
              spacing={2}
            >
              <Typography sx={{ color: neutral[500] }}>{metric.manualTitle}</Typography>
            </Stack>
          )}
          <Stack
            direction='row'
            spacing={2}
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            {metric.draftCount > 0 && (
              <Button
                variant='outlined'
                size='small'
                onClick={() => navigate(`/admin/dtbs/packages/${metric.id}`)}
                sx={{
                  borderColor: neutral[300],
                  color: neutral[700],
                  '&:hover': {
                    borderColor: neutral[400],
                    backgroundColor: neutral[50],
                  },
                }}
              >
                Approve {metric.draftCount} DTB{metric.draftCount !== 1 ? 's' : ''}
              </Button>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
}
